export default __webpack_public_path__ + "static/media/ng.2390143a.svg";